import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import { parse, format } from 'date-fns'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByObjectCode = ({
  match: {
    params: { year, deptNo, charCode, objCode }
  },
  location
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(
        `/GetDepartmentSpending/${year}/${deptNo}/${charCode}/${objCode}`
      )
      const _data = result.data.map(d => ({
        name: d.Comment.trim(),
        date: format(parse(d.Date, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd'),
        fund: d.FundName.trim(),
        data: d.Amount,
        checkNo: d.CheckNo,
        vendor: d.Vendor ? d.Vendor.trim() : ''
      }))
      setData(_data.sort((a, b) => a.date.localeCompare(b.date)))
    }

    loadData()
  }, [charCode, deptNo, location.search, objCode, year])

  return (
    <DataLayout year={year}>
      <Table
        data={{
          headers: [
            {
              title: 'Description',
              dataKey: 'name'
            },
            {
              title: 'Date',
              dataKey: 'date'
            },
            {
              title: 'Fund',
              dataKey: 'fund'
            },
            {
              title: 'Vendor',
              dataKey: 'vendor'
            },
            {
              title: 'Check #',
              dataKey: 'checkNo'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data,
          defaultSort: {
            field: 'date',
            ascending: true
          }
        }}
      />
    </DataLayout>
  )
}

export default SpendingByObjectCode
